import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "row"
  ]

  connect () {
    const url = new URL(window.location.href)
    const sortParam = url.searchParams.get("sort")

    if (!sortParam) {
      this._scrollToRecentTrainingSessions()
    }
  }

  _scrollToRecentTrainingSessions () {
    const fifteenDaysAgo = Date.now() - (15 * 24 * 60 * 60 * 1000)
    const recentTrainingSession = this.rowTargets.find(row => {
      const startDate = parseInt(row.dataset.startDate) * 1000 // Convert from seconds to milliseconds
      return startDate > fifteenDaysAgo
    })

    if (recentTrainingSession) {
      recentTrainingSession.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
}
